import { defineStore } from 'pinia'
import { API } from '@/modules/api'

export const useSessionStore = defineStore('session', {
  state: () => ({
    familyUserId: null as null | number,
    localeCode: 'en',
    timeoutInterval: null as null | number,
    lastRequestAt: null as null | number,
    sessionExpiresAt: null as null | number,
    checkLoggedIn: null,
    processingFeesAcceptedThisSession: false as boolean
  }),
  persist: true,
  actions: {
    clear() {
      this.familyUserId = null
      this.localeCode = 'en'
      this.timeoutInterval = null
      this.lastRequestAt = null
      this.sessionExpiresAt = null
      this.processingFeesAcceptedThisSession = false
    },
    getFamilyUserId() {
      return this.familyUserId
    },
    getLocaleCode() {
      return this.localeCode
    },
    getSessionTimeoutAt(): null | number {
      if (this.timeoutInterval === null || this.lastRequestAt === null) {
        return null
      }

      return this.lastRequestAt + this.timeoutInterval * 60000
    },
    getSessionTimedOut() {
      const sessionTimeoutAt = this.getSessionTimeoutAt()
      if (sessionTimeoutAt === null) {
        return false
      } else {
        return Date.now() >= sessionTimeoutAt
      }
    },
    getSessionExpiresAt() {
      return this.sessionExpiresAt
    },
    getSessionExpired() {
      const sessionExpiredAt = this.getSessionExpiresAt()
      if (sessionExpiredAt === null) {
        return false
      } else {
        return Date.now() >= sessionExpiredAt
      }
    },
    setFamilyUserId(familyUserId: null | number) {
      this.familyUserId = familyUserId
    },
    setLocaleCode(localeCode: string, persist = true) {
      this.localeCode = localeCode
      if (persist && this.familyUserId !== null) {
        API.Post.setLocaleCode(localeCode)
      }
    },
    setTimeoutInterval(minutes: number) {
      this.timeoutInterval = minutes
    },
    setLastRequestAt(time: number) {
      this.lastRequestAt = time
    },
    setSessionExpiresAt(time: number) {
      this.sessionExpiresAt = time
    },
    madeRequest() {
      this.lastRequestAt = Date.now()
    },
    setLoggedIn() {
      this.checkLoggedIn = true
    },
    setProcessingFeesAcceptedThisSession(accepted: boolean) {
      this.processingFeesAcceptedThisSession = accepted
    }
  }
})
